/* eslint-disable */
// @ts-nocheck

import React from "react";
import { TextArea, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  id?: string;
  className?: string;
  labelText?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: any) => void;
  value?: string;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
  rows?: number;
}

const TextAreaField = ({
  id,
  className,
  labelText,
  placeholder,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
  tooltipText,
  required,
  rows,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div
        className="form-label"
        data-cy={`${labelText.replaceAll(" ", "")}-textArealabel`}
      >
        <FormLabel>
          {labelText} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${labelText.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
      <TextArea
        id={id}
        className={className}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        invalid={invalid}
        invalidText={invalidText}
        onChange={(event: { target: { value: string } }) => {
          onChange(event.target.value);
        }}
        required={required}
        data-cy={`${labelText.replaceAll(" ", "")}-input`}
        rows={rows}
      />
    </div>
  );
};
export default TextAreaField;
